import { WHY_US, BUSINESS } from "@/data/site";
import Icon from "@/components/Icon";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function WhyUs() {
    const { t } = useLang();
    return (
        <section id="about" data-testid="why-us-section" className="relative py-24 md:py-32 bg-surface border-y border-ink/5 overflow-hidden">
            <div className="absolute top-0 left-1/3 w-[26rem] h-[26rem] bg-cyan2/8 blur-[130px] rounded-full pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <Reveal>
                    <Eyebrow>{t.why.eyebrow}</Eyebrow>
                    <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-ink mt-4 max-w-2xl">
                        {t.why.headingA}<span className="text-cyan2">{t.why.headingB}</span>
                    </h2>
                    <p className="mt-5 max-w-xl text-ice/60 text-base md:text-lg">
                        {t.why.sub}
                    </p>
                </Reveal>
                <div className="mt-14 grid gap-5 grid-cols-2 lg:grid-cols-3">
                    {WHY_US.map((w, i) => (
                        <Reveal key={w.icon} delay={(i % 3) * 0.1}>
                            <div
                                data-testid={`why-card-${w.icon}`}
                                className="group h-full rounded-2xl border border-ink/5 bg-navy/60 p-6 md:p-8 hover:border-cyan2/30 transition-colors duration-300"
                            >
                                <span className="inline-flex w-11 h-11 rounded-full border border-cyan2/25 bg-cyan2/5 items-center justify-center group-hover:scale-110 group-hover:shadow-[0_0_22px_rgba(0,207,255,0.35)] transition-all duration-300">
                                    <Icon name={w.icon} size={20} className="text-cyan2" />
                                </span>
                                <h3 className="font-heading text-base md:text-lg font-semibold text-ink mt-4">
                                    {t.why.cards[i]}
                                </h3>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2} className="mt-10">
                    <p className="font-mono2 text-xs tracking-[0.25em] uppercase text-ice/40">
                        {BUSINESS.addressShort} · {BUSINESS.phoneDisplay}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
